import { Injectable } from '@angular/core';
import { StepTwoModel } from '../../../shared/models/states/loan/loan-step-two.model';
import { BrowserStorageService, StorageKeys } from '../../services/browser-storage.service';
import { ApplicantService } from '../../services/loan/applicant.api.service';
import { StepOneState } from './step-one-state';
import { lastValueFrom } from 'rxjs';
import { NonjointApplicantService } from '../../services/loan/nonjoint-applicant.api.service';

@Injectable({
    providedIn: 'root',
})
export class StepTwoState {
    private _state?: StepTwoModel;

    constructor(private bss: BrowserStorageService, private nonjointApplicantService: NonjointApplicantService, private applicantService: ApplicantService) { }

    get state() {
        if (!this._state) {
            const item = this.bss.getSessionItem(StorageKeys.StepTwoModel);
            if (item) this._state = item;
            return item ?? undefined;
        }
        return this._state;
    }

    get isCoapplicant() {
        return this.state?.applicant.applicant_type === "Nonjoint" || this.state?.applicant.applicant_type === "Joint";
    }

    get isNonjointApplicant() {
        return this.state?.applicant.applicant_type === "Nonjoint";
    }

    get isJointApplicant() {
        return this.state?.applicant.applicant_type === "Joint";
    }

    set state(value: StepTwoModel | undefined) {
        this.bss.setSessionItem(StorageKeys.StepTwoModel, value);
        this._state = value;
    }

    async syncDB(update: boolean) {
        if (this._state === undefined) return;
        await this.update(this._state);
    }

    private async update(value: StepTwoModel) {
        if (!value.applicant.uuid) return;
        this.isCoapplicant ?
            await lastValueFrom(this.applicantService.updateApplicant(value.applicant.uuid, value.applicant)) :
            await lastValueFrom(this.nonjointApplicantService.updateNonjointApplicant(value.applicant.uuid, value.applicant))
        this.bss.setSessionItem(StorageKeys.StepTwoModel, this._state);
    }

}
